const resource = {
    resource_identifier_in_use: 'Идентификатор API {{indicator}} уже используется',
    cannot_delete_management_api: 'Не удается удалить управляемый API GptHouse.',
    cannot_modify_management_api: 'Не удается изменить управляемый API GptHouse.',
};
export default Object.freeze(resource);
